export default "__VITE_ASSET__3988e65d__"